<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-6">
          <h3 v-if="isNewReport"><i class="fa fa-fw fa-book"></i> {{ _('Create a new report') }}</h3>
          <h3 v-else><i class="fa fa-fw fa-book"></i> {{ _('Edit scheduled report') }}</h3>
					<div class="form-group">
						<input type="hidden" id="reportId" value="" />
						<label for="reportType">{{ _('Type') }}</label>
						<select class="form-control" id="reportType" v-model="reportType">
              <option value="">{{ _('Select') }}</option>
              <optgroup :label="_('Accounting reports')">
							  <option v-for="rt in accountingReportTypes" :value="rt">{{ rt.name }}</option>
						  </optgroup>
              <optgroup :label="_('List reports')">
							  <option v-for="rt in listReportTypes" :value="rt">{{ rt.name }}</option>
						  </optgroup>
              <optgroup :label="_('Customer reports')" v-if="customerReportTypes.length">
							  <option v-for="rt in customerReportTypes" :value="rt">{{ rt.name }}</option>
						  </optgroup>
              <optgroup :label="_('Movie reports')">
							  <option v-for="rt in movieReportTypes" :value="rt">{{ rt.name }}</option>
						  </optgroup>
              <optgroup :label="_('Reservation reports')">
							  <option v-for="rt in reservationReportTypes" :value="rt">{{ rt.name }}</option>
						  </optgroup>
              <optgroup :label="_('Other reports')">
							  <option v-for="rt in otherReportTypes" :value="rt">{{ rt.name }}</option>
						  </optgroup>
						</select>
					</div>
					<div class="form-group">
						<label for="reportTitle">{{ _('Title') }}</label>
						<input type="text" v-model="reportTitle" class="form-control" id="reportTitle" :placeholder="_('A descriptive title for the report')" />
					</div>
					<div class="form-group">
						<label for="reportTime">{{ _('Run the report') }}</label>
						<select class="form-control" id="reportTime" v-model="reportTime">
              <option value="now">{{ _('Now') }}</option>
							<option value="scheduled">{{ _('On a schedule') }}</option>
						</select>
					</div>
					<div class="form-group" id="reportDaySelectors" v-if="showReportDaySelectors">
						<div class="radio">
							<label><input type="radio" name="report_days_mode" id="reportEveryDay" v-model="reportDaily" value="every" /> {{ _('Every day') }}</label>
						</div>
						<div class="radio">
							<label><input type="radio" name="report_days_mode" id="reportWeekdays" v-model="reportDaily" value="selected-weekdays" /> {{ _('On selected weekdays') }}</label>
						</div>
						<div class="itemselector-container">
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_weekdays" id="reportMondays" value="1" :disabled="isWeekdayDisabled" v-model="reportWeekdays" /> {{ _('Mon') }}
							</label>
							<label class="checkbox-inline">
  						  <input type="checkbox" name="report_weekdays" id="reportTuesdays" value="2" :disabled="isWeekdayDisabled" v-model="reportWeekdays" /> {{ _('Tue') }}
							</label>
							<label class="checkbox-inline">
							  <input type="checkbox" name="report_weekdays" id="reportWednesdays" value="3" :disabled="isWeekdayDisabled" v-model="reportWeekdays" /> {{ _('Wed') }}
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_weekdays" id="reportThursdays" value="4" :disabled="isWeekdayDisabled" v-model="reportWeekdays" /> {{ _('Thu') }}
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_weekdays" id="reportFridays" value="5" :disabled="isWeekdayDisabled" v-model="reportWeekdays" /> {{ _('Fri') }}
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_weekdays" id="reportSaturdays" value="6" :disabled="isWeekdayDisabled" v-model="reportWeekdays" /> {{ _('Sat') }}
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_weekdays" id="reportSundays" value="7" :disabled="isWeekdayDisabled" v-model="reportWeekdays" /> {{ _('Sun') }}
							</label>
						</div>
						<div class="radio">
							<label><input type="radio" name="report_days_mode" id="reportDays" v-model="reportDaily" value="selected-days" /> {{ _('On selected days of month') }}</label>
						</div>
						<div class="itemselector-container seven-items">
							<label v-for="day in 31" class="checkbox-inline"><input type="checkbox" name="report_days" :value="day" :disabled="isDayDisabled" v-model="reportDays" /> {{ day }}</label>
              <div style="clear: both"></div>
						</div>
					</div>
					<div class="form-group" id="reportMonthSelectors" v-if="showReportMonthSelectors">
						<div class="radio">
							<label><input type="radio" name="report_months_mode" id="reportEveryMonth" v-model="reportMonthly" value="every" /> {{ _('Every month') }}</label>
						</div>
						<div class="radio">
							<label><input type="radio" name="report_months_mode" id="reportMonths" v-model="reportMonthly" value="selected" /> {{ _('On selected months') }}</label>
						</div>
						<div class="itemselector-container">
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportJanuary" value="1" :disabled="isMonthDisabled" v-model="reportMonths" /> 1
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportFebruary" value="2" :disabled="isMonthDisabled" v-model="reportMonths" /> 2
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportMarch" value="3" :disabled="isMonthDisabled" v-model="reportMonths" /> 3
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportApril" value="4" :disabled="isMonthDisabled" v-model="reportMonths" /> 4
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportMay" value="5" :disabled="isMonthDisabled" v-model="reportMonths" /> 5
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportJune" value="6" :disabled="isMonthDisabled" v-model="reportMonths" /> 6
							</label>
							<br />
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportJuly" value="7" :disabled="isMonthDisabled" v-model="reportMonths" /> 7
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportAugust" value="8" :disabled="isMonthDisabled" v-model="reportMonths" /> 8
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportSeptember" value="9" :disabled="isMonthDisabled" v-model="reportMonths" /> 9
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportOctober" value="10" :disabled="isMonthDisabled" v-model="reportMonths" /> 10
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportNovember" value="11" :disabled="isMonthDisabled" v-model="reportMonths" /> 11
							</label>
							<label class="checkbox-inline">
						  	<input type="checkbox" name="report_months" id="reportDecember" value="12" :disabled="isMonthDisabled" v-model="reportMonths" /> 12
							</label>
						</div>
					</div>
					<div class="form-group" id="reportTimeSelectors" v-if="showReportTimeSelectors">
						<label>{{ _('At times:') }}</label>
						<div id="startTimesContainer">
              <button class="btn btn-success" v-for="time in reportTimes" v-on:click="removeTime(time)">{{ time }}<i class="fa fa-fw fa-times"></i></button>
							<p id="noStartTimes" v-if="!reportTimes.length">{{ _('No times defined.') }}</p>
						</div>
            <div class="flex-row">
              <TimePicker :shortLocale="shortLocale" v-model="newTime" :format="timeFormat" :placeholder="_('Select time')"/>
              <button class="btn btn-success" type="button" id="addStartTime" v-on:click="addTime"><i class="fa fa-fw fa-clock-o"></i> {{ _('Add time') }}</button>
            </div>
					</div>
					<div class="form-group">
						<label for="reportRange">{{ _('Date range') }}</label>
						<div class="row">
							<div class="col-md-6">
								<span class="input-group">
									<span class="input-group-addon"><i class="fa fa-fw fa-step-backward"></i></span>
									<select class="form-control" id="reportRangeStart" v-model="reportRangeStart">
										<option v-for="range in reportStartRanges" :value="range.id">{{ range.name }}</option>
									</select>
								</span>
								<div id="exactStartDateSelector" class="exact-date-selector" v-if="showExactStartDate">
									<span class="input-group">
                    <DatePicker v-model="exactStartDate" :shortLocale="shortLocale" :placeholder="_('Select date')"></DatePicker>
									</span>
								</div>
							</div>
							<div class="col-md-6">
								<span class="input-group">
									<select class="form-control" id="reportRangeEnd" v-model="reportRangeEnd">
										<option v-for="range in reportEndRanges" :value="range.id">{{ range.name }}</option>
									</select>
									<span class="input-group-addon"><i class="fa fa-fw fa-step-forward"></i></span>
								</span>
								<div id="exactEndDateSelector" class="exact-date-selector" v-if="showExactEndDate">
									<span class="input-group">
                    <DatePicker v-model="exactEndDate" :shortLocale="shortLocale" :placeholder="_('Select date')"></DatePicker>
									</span>
								</div>
							</div>
						</div>
					</div>
					<div class="form-group" v-if="reportType.id !== 'accommodationstatistics'">
						<label for="reportFormat">{{ _('Format') }}</label>
						<select class="form-control" id="reportFormat" v-model="reportFormat">
              <option value="xlsx" v-if="showXlsxOutput">{{ _('Excel') }}</option>
              <option value="html" v-if="showHtmlOutput">{{ _('HTML') }}</option>
              <option value="pdf" v-if="showPdfOutput">{{ _('PDF') }}</option>
						</select>
					</div>
					<div class="form-group">
						<label for="reportOutput">{{ _('Output') }}</label>
						<select class="form-control" id="reportOutput" v-model="reportOutput">
              <option value="download" v-if="reportType.id !== 'accommodationstatistics'">{{ _('View') }} / {{ _('Download') }}</option>
              <option value="email" v-if="reportType.id !== 'accommodationstatistics'">{{ _('Email') }}</option>
              <option value="archive">{{ _('Archive only') }}</option>
						</select>
					</div>
					<div class="form-group" id="reportEmailContainer" v-if="showReportEmailContainer">
						<label for="reportEmail">{{ _('Email') }}</label>
						<input type="email" class="form-control" id="reportEmail" :placeholder="_('A comma-separated list of emails to send the report to')" v-model="reportEmail" />
					</div>
          <div class="form-group form-check" id="sendaccommodationstatistics" v-if="reportType.id === 'accommodationstatistics' && isFeatureEnabled('statisticsfinland')">
            <input type="checkbox" class="form-check-input" name="send_accommodation_statistics" id="sendAccommodationStatistics" v-model="sendAccommodationStatistics" />
            <label for="sendAccommodationStatistics" class="form-check-label">&nbsp;{{ _('Send to Statistics Finland') }}</label>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 rightcol" id="filterCol" v-if="showFilters">
          <h3>{{ _('Filter the results') }}</h3>
            <p class="help-block" v-if="groupsCustomersByEmail">{{ _('Bills are matched by the selected customer\'s email. Walk-in bills with the same address are included.') }}</p>
            <p class="help-block" v-if="reportType.id === 'customerltv'">{{ _('Leave empty to include every customer.') }}</p>
					<div class="form-group" v-if="showCategoryFilter">
						<label for="reportCategories">{{ _('Categories') }}</label>
            <multiselect v-model="reportCategories" :options="allReportCategories" :multiple="true" :searchable="true" :allow-empty="true" :custom-label="nameWithId" label="name" track-by="id" :placeholder="_('Select')">
              <template #noResult>{{ _('No results found.') }}</template>
            </multiselect>
          </div>
					<div class="form-group" v-if="showProductTypeFilter">
						<label for="reportProductTypes">{{ _('Product types') }}</label>
            <multiselect v-model="reportProductTypes" :options="allReportProductTypes" :multiple="true" :searchable="true" :allow-empty="true" label="title" track-by="fulltype" :placeholder="_('Select')">
              <template #noResult>{{ _('No results found.') }}</template>
            </multiselect>
          </div>
						<div class="form-group" v-if="showProductFilter">
						<label for="reportProducts">{{ reportType.id === 'customercohort' ? _('Entry products') : _('Products') }}</label>
            <multiselect v-model="reportProducts" :options="allReportProducts" :multiple="true" :searchable="true" :allow-empty="true" :custom-label="nameWithId" label="name" track-by="id" :placeholder="_('Select')">
              <template #noResult>{{ _('No results found.') }}</template>
            </multiselect>
          </div>
					<div class="form-group" v-if="showFollowupProductFilter">
						<label for="reportFollowupProducts">{{ _('Follow-up products') }}</label>
            <multiselect v-model="reportFollowupProducts" :options="allReportProducts" :multiple="true" :searchable="true" :allow-empty="true" :custom-label="nameWithId" label="name" track-by="id" :placeholder="_('Select')">
              <template #noResult>{{ _('No results found.') }}</template>
            </multiselect>
            <p class="help-block">{{ _('Leave empty to rank other products the cohort bought.') }}</p>
          </div>
					<div class="form-group" v-if="showCustomerFilter">
						<label for="reportCustomers">{{ _('Customer') }}</label>
            <multiselect v-model="reportCustomers" :options="allReportCustomers" :multiple="true" :searchable="true" :internal-search="false" :loading="customersLoading" :allow-empty="true" :custom-label="customerWithEmail" label="name" track-by="id" :placeholder="_('Type to search customers')" @search-change="searchCustomers">
              <template #noResult>{{ _('No results found.') }}</template>
            </multiselect>
          </div>
					<div class="form-group" v-if="showResourceFilter">
						<label for="reportResources">{{ _('Resources') }}</label>
            <multiselect v-model="reportResources" :options="allReportResources" :multiple="true" :searchable="true" :allow-empty="true" :custom-label="nameWithId" label="name" track-by="id" :placeholder="_('Select')">
              <template #noResult>{{ _('No results found.') }}</template>
            </multiselect>
          </div>
					<div class="form-group" v-if="showSaleschannelFilter">
						<label for="reportChannels">{{ _('Sales channels') }}</label>
            <multiselect v-model="reportChannels" :options="allReportChannels" :multiple="true" :searchable="true" :allow-empty="true" label="origin" track-by="origin" :placeholder="_('Select')">
              <template #noResult>{{ _('No results found.') }}</template>
            </multiselect>
          </div>
					<div class="form-group" v-if="showPosFilter">
						<label for="reportPoses">{{ _('Points of use') }}</label>
            <multiselect v-model="reportPoses" :options="allReportPoses" :multiple="true" :searchable="true" :allow-empty="true" label="name" track-by="id" :placeholder="_('Select')">
              <template #noResult>{{ _('No results found.') }}</template>
            </multiselect>
          </div>
					<div class="form-group" v-if="showDeliveryMethodFilter">
						<label for="reportPoses">{{ _('Delivery method') }}</label>
            <multiselect v-model="reportDeliveryMethods" :options="allDeliveryMethods" :multiple="true" :searchable="true" :allow-empty="true" label="name" track-by="id" :placeholder="_('Select')">
              <template #noResult>{{ _('No results found.') }}</template>
            </multiselect>
          </div>
				</div>
      </div>
			<div>
        <div class="flex-row">
          <button v-if="showGenerateButton" class="btn btn-success" type="button" id="generateReportButton" v-on:click="generateReport" :disabled="!isGenerateEnabled"><i class="fa fa-fw fa-cogs"></i> {{ _('Generate') }}</button>
          <button v-if="showSaveButton" class="btn btn-success" type="button" id="generateReportButton" v-on:click="generateReport" :disabled="!isGenerateEnabled"><i class="fa fa-fw fa-save"></i> {{ _('Save') }}</button>
					<button v-if="showRemoveButton" class="btn btn-danger" type="button" id="removeReportButton" v-on:click="deleteReport"><i class="fa fa-fw fa-trash"></i> {{ deleteClicked ? _('Confirm') : _('Delete') }}</button>
					<button class="btn btn-default" type="button" id="resetReportButton" v-on:click="reset"><i class="fa fa-fw fa-times"></i> {{ _('Clear') }}</button>
        </div>
        <p style="margin-top: 10px">{{ _('Note: Some reports may take longer to generate, while others may be created instantly.') }} {{ _('If the report takes a long time to generate or does not show up at all, try a shorter time frame.') }}</p>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import Multiselect from 'vue-multiselect'
import DatetimePicker from '~/components/DatetimePicker'
import { DateTime } from 'luxon'
import settingshelpers from '~/lib/settingshelpers'
import reporttypes from '~/lib/reporttypes'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      reportId: 0,
      requestId: null,
      selectedOutputs: {},
      reportType: '',
      reportTitle: '',
      reportTime: 'now',
      reportDaily: 'every',
      reportMonthly: 'every',
      reportRangeStart: '',
      reportRangeEnd: '',
      reportTimes: [],
      reportFormat: 'xlsx',
      reportOutput: 'download',
      reportEmail: '',
      reportWeekdays: [],
      reportDays: [],
      reportMonths: [],
      allReportCategories: [],
      allReportProductTypes: [],
      allReportProducts: [],
      allReportResources: [],
      allReportChannels: [],
      allReportPoses: [],
      allDeliveryMethods: [],
      reportCategories: [],
      reportProductTypes: [],
      reportProducts: [],
      reportResources: [],
      reportChannels: [],
      reportPoses: [],
      reportDeliveryMethods: [],
      allReportCustomers: [],
      reportCustomers: [],
      reportFollowupProducts: [],
      customersLoading: false,
      exactStartDate: '',
      exactEndDate: '',
      newTime: '',
      deleteClicked: false,
      deleteTimeout: false,
      sendAccommodationStatistics: false
    }
  },
  mixins: [components, reporttypes, settingshelpers],
  computed: {
    reportStartRanges () {
      return [
        { 'id': '', 'name': this._('Select first day') },
        { 'id': 'exact', 'name': this._('Exact date') },
        { 'id': '1 January 1970 00:00', 'name': this._('All time') },
        { 'id': 'today', 'name': this._('Today') },
        { 'id': 'yesterday', 'name': this._('Yesterday') },
        { 'id': '-2 days 00:00', 'name': this._('2 days ago') },
        { 'id': '-3 days 00:00', 'name': this._('3 days ago') },
        { 'id': '-4 days 00:00', 'name': this._('4 days ago') },
        { 'id': '-5 days 00:00', 'name': this._('5 days ago') },
        { 'id': '-6 days 00:00', 'name': this._('6 days ago') },
        { 'id': '-1 week 00:00', 'name': this._('1 week ago') },
        { 'id': '-2 weeks 00:00', 'name': this._('2 weeks ago') },
        { 'id': 'last monday', 'name': this._('last Monday') },
        { 'id': 'last tuesday', 'name': this._('last Tuesday') },
        { 'id': 'last wednesday', 'name': this._('last Wednesday') },
        { 'id': 'last thursday', 'name': this._('last Thursday') },
        { 'id': 'last friday', 'name': this._('last Friday') },
        { 'id': 'last saturday', 'name': this._('last Saturday') },
        { 'id': 'last sunday', 'name': this._('last Sunday') },
        { 'id': 'first day of this month 00:00', 'name': this._('Start of this month') },
        { 'id': 'first day of last month 00:00', 'name': this._('Start of last month') },
        { 'id': 'first day of january 00:00', 'name': this._('Start of this year') },
        { 'id': 'first day of january last year 00:00', 'name': this._('Start of last year') }
      ]
    },
    reportEndRanges () {
      return [
        { 'id': '', 'name': this._('Select last day') },
        { 'id': 'exact', 'name': this._('Exact date') },
        { 'id': 'last day of december this year 00:00', 'name': this._('End of this year') },
        { 'id': 'last day of this month 00:00', 'name': this._('End of this month') },
        { 'id': 'today', 'name': this._('Today') },
        { 'id': 'yesterday', 'name': this._('Yesterday') },
        { 'id': '-2 days 00:00', 'name': this._('2 days ago') },
        { 'id': '-3 days 00:00', 'name': this._('3 days ago') },
        { 'id': '-4 days 00:00', 'name': this._('4 days ago') },
        { 'id': '-5 days 00:00', 'name': this._('5 days ago') },
        { 'id': '-6 days 00:00', 'name': this._('6 days ago') },
        { 'id': '-1 week 00:00', 'name': this._('1 week ago') },
        { 'id': '-2 weeks 00:00', 'name': this._('2 weeks ago') },
        { 'id': 'last monday', 'name': this._('last Monday') },
        { 'id': 'last tuesday', 'name': this._('last Tuesday') },
        { 'id': 'last wednesday', 'name': this._('last Wednesday') },
        { 'id': 'last thursday', 'name': this._('last Thursday') },
        { 'id': 'last friday', 'name': this._('last Friday') },
        { 'id': 'last saturday', 'name': this._('last Saturday') },
        { 'id': 'last sunday', 'name': this._('last Sunday') },
        { 'id': 'last day of last month 00:00', 'name': this._('End of last month') },
        { 'id': 'last day of december last year 00:00', 'name': this._('End of last year') }
      ]
    },
    sendReportTimes () {
      return this.reportTimes.map(t => DateTime.fromFormat(t, this.timeFormat).toFormat('H.mm'))
    },
    showReportDaySelectors () {
      return this.reportTime === 'scheduled'
    },
    showReportTimeSelectors () {
      return this.reportTime === 'scheduled'
    },
    showReportMonthSelectors () {
      return this.reportTime === 'scheduled'
    },
    showReportEmailContainer () {
      return this.reportOutput === 'email'
    },
    showExactStartDate () {
      return this.reportRangeStart === 'exact'
    },
    showExactEndDate () {
      return this.reportRangeEnd === 'exact'
    },
    showFilters () {
      if (this.reportType && this.reportType.props && this.reportType.props.includes('nofilters')) {
        return false
      }
      return this.showCategoryFilter ||
        this.showProductTypeFilter ||
        this.showProductFilter ||
        this.showFollowupProductFilter ||
        this.showCustomerFilter ||
        this.showResourceFilter ||
        this.showSaleschannelFilter ||
        this.showPosFilter ||
        this.showDeliveryMethodFilter
    },
    showCategoryFilter () {
      if (this.reportType && this.reportType.props && this.reportType.props.includes('nocategoryfilter')) {
        return false
      }
      return true
    },
    showProductTypeFilter () {
      if (this.reportType && this.reportType.props && this.reportType.props.includes('noproducttypefilter')) {
        return false
      }
      return true
    },
    showProductFilter () {
      if (this.reportType && this.reportType.props && this.reportType.props.includes('noproductfilter')) {
        return false
      }
      return true
    },
    showResourceFilter () {
      if (this.reportType && this.reportType.props && this.reportType.props.includes('noresourcefilter')) {
        return false
      }
      return true
    },
    showSaleschannelFilter () {
      if (this.reportType && this.reportType.props && this.reportType.props.includes('nosaleschannelfilter')) {
        return false
      }
      return true
    },
    showPosFilter () {
      if (this.reportType && this.reportType.props && this.reportType.props.includes('noposfilter')) {
        return false
      }
      return true
    },
    showDeliveryMethodFilter () {
      if (this.reportType && this.reportType.props && this.reportType.props.includes('nodeliverymethodfilter')) {
        return false
      }
      return true
    },
    showCustomerFilter () {
      return !!(this.reportType && this.reportType.props && this.reportType.props.includes('customerfilter'))
    },
    groupsCustomersByEmail () {
      return !!(this.reportType && ['customerpurchases', 'customercohort', 'customerltv'].includes(this.reportType.id))
    },
    showFollowupProductFilter () {
      return !!(this.reportType && this.reportType.props && this.reportType.props.includes('followupproductfilter'))
    },
    allowsEmptyDateRange () {
      return this.reportType && (this.reportType.id === 'customerpurchases' || this.reportType.id === 'customerltv')
    },
    showHtmlOutput () {
      if (this.reportType && this.reportType.props && this.reportType.props.includes('nohtml')) {
        return false
      }
      return true
    },
    showPdfOutput () {
      if (this.reportType && this.reportType.props && this.reportType.props.includes('nopdf')) {
        return false
      }
      return true
    },
    showXlsxOutput () {
      if (this.reportType && this.reportType.props && this.reportType.props.includes('noxlsx')) {
        return false
      }
      return true
    },
    isWeekdayDisabled () {
      return this.reportDaily !== 'selected-weekdays'
    },
    isDayDisabled () {
      return this.reportDaily !== 'selected-days'
    },
    isMonthDisabled () {
      return this.reportMonthly !== 'selected'
    },
    isGenerateEnabled () {
      if (!this.reportType) {
        return false
      }
      if (this.reportType.id === 'customerpurchases') {
        if (!this.reportCustomers.length) {
          return false
        }
        if (this.reportCustomers.some(customer => !customer.email || !String(customer.email).trim())) {
          return false
        }
      }
      if (this.reportType.id === 'customercohort' && !this.reportProducts.length) {
        return false
      }
      if (!this.allowsEmptyDateRange && (!this.reportRangeStart || !this.reportRangeEnd)) {
        return false
      }
      if (this.reportRangeStart === 'exact' && !this.exactStartDate) {
        return false
      }
      if (this.reportRangeEnd === 'exact' && !this.exactEndDate) {
        return false
      }
      if(this.reportTime === 'scheduled' && !this.reportTimes.length) {
        return false
      }
      return true
    },
    isNewReport () {
      return parseInt(this.reportId) === 0
    },
    shortLocale () {
      return this.locale.split('_')[0]
    },
    showGenerateButton () {
      return parseInt(this.reportId) === 0
    },
    showSaveButton () {
      return parseInt(this.reportId) > 0
    },
    showRemoveButton () {
      return parseInt(this.reportId) > 0
    }
  },
  watch: {
    reportType: {
      handler(newValue) {
        if (newValue && newValue.id === 'accommodationstatistics') {
          this.reportOutput = 'archive'
        }
        this.ensureSupportedFormat()
      }
    }
  },
  methods: {
    getTypeName (product) {
      return product.type
    },
    nameWithId ({ id, name }) {
      return id + ': ' + name
    },
    mapReportCustomer (d) {
      return {
        id: d.id,
        name: d.name || d.email || String(d.id),
        email: d.email || ''
      }
    },
    customerWithEmail ({ id, name, email }) {
      const label = id + ': ' + (name || email || id)
      if (email && email !== name) {
        return label + ' <' + email + '>'
      }
      return label
    },
    makeRequestId () {
      var ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      var ID_LENGTH = 8
      var rtn = ''
      for (var i = 0; i < ID_LENGTH; i++) {
        rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length))
      }
      this.requestId = rtn
    },
    ensureSupportedFormat () {
      const typeId = this.reportType && this.reportType.id
      if (!typeId) {
        return
      }
      // resolveSupportedFormat returns null for types that don't use the
      // format concept at all (e.g. accommodationstatistics) - keep whatever
      // format is currently selected in that case rather than clearing it.
      this.reportFormat = this.resolveSupportedFormat(typeId, this.reportFormat) || this.reportFormat
    },
    async generateReport () {
      this.ensureSupportedFormat()
      this.makeRequestId()
      this.selectedOutputs[this.requestId] = this.reportOutput
      let obj = { 
        requestid: this.requestId,
        creator: this.user,
        type: this.reportType.id,
        title: this.reportTitle,
        time: this.reportTime,
        start: this.reportRangeStart === 'exact'
          ? DateTime.fromJSDate(this.exactStartDate.toDate ? this.exactStartDate.toDate() : this.exactStartDate).toFormat('d.M.yyyy')
          : (this.reportRangeStart || (this.allowsEmptyDateRange ? '1 January 1970 00:00' : this.reportRangeStart)),
        end: this.reportRangeEnd === 'exact'
          ? DateTime.fromJSDate(this.exactEndDate.toDate ? this.exactEndDate.toDate() : this.exactEndDate).toFormat('d.M.yyyy')
          : (this.reportRangeEnd || (this.allowsEmptyDateRange ? 'today' : this.reportRangeEnd)),
        format: this.reportFormat,
        output: this.reportOutput,
        email: this.reportEmail,
        categories: this.showCategoryFilter ? this.reportCategories.map(({ id }) => id) : [],
        products: this.showProductFilter ? this.reportProducts.map(({ id }) => id) : [],
        producttypes: this.showProductTypeFilter ? this.reportProductTypes.map(({ fulltype }) => fulltype) : [],
        resources: this.showResourceFilter ? this.reportResources.map(({ id }) => id) : [],
        saleschannels: this.showSaleschannelFilter ? this.reportChannels.map(({ origin }) => origin) : [],
        poses: this.showPosFilter ? this.reportPoses.map(({ id }) => id) : [],
        deliverymethods: this.showDeliveryMethodFilter ? this.reportDeliveryMethods.map(({ id }) => id) : [],
        emails: this.showCustomerFilter ? this.reportCustomers.map(({ email }) => email).filter(email => email && String(email).trim()) : [],
        followup_products: this.showFollowupProductFilter ? this.reportFollowupProducts.map(({ id }) => id) : [],
        weekdays: this.isWeekdayDisabled ? [] : this.reportWeekdays,
        days: this.isDayDisabled ? [] : this.reportDays,
        months: this.isMonthDisabled ? [] : this.reportMonths,
        times: this.sendReportTimes,
        enabled: 1,
        sendstatistics: this.sendAccommodationStatistics
      }
      let response
      if (parseInt(this.reportId)) {
        obj.id = this.reportId
        axios.put(this.baseDomain + this.shopId + '/scheduledreports/' + obj.id + '.json?apikey=' + this.apiKey, obj)
      } else {
        response = await axios.post(this.baseDomain + this.shopId + '/scheduledreports.json?apikey=' + this.apiKey, obj)
      }
      if (response && response.data && response.data.hasOwnProperty && response.data.hasOwnProperty('queue')) {
        if (response.data.queue > 0) {
          this.showNotification(this._('Report queued.') + ' ' + this._('There are currently %s jobs in the queue.').replace('%s', response.data.queue))
        } else {
          this.showNotification(this._('Report queued.'))
        }
      }
      if (this.isFeatureEnabled('statisticsfinland') && this.sendAccommodationStatistics) {
        this.sendStatisticsFinlandData()
      }
      this.reset()
    },
    async sendStatisticsFinlandData() {
      let start = this.reportRangeStart === 'exact' ? DateTime.fromJSDate(this.exactStartDate.toDate ? this.exactStartDate.toDate() : this.exactStartDate).toFormat('d.M.yyyy') : this.reportRangeStart
      let end = this.reportRangeEnd === 'exact' ? DateTime.fromJSDate(this.exactEndDate.toDate ? this.exactEndDate.toDate() : this.exactEndDate).toFormat('d.M.yyyy') : this.reportRangeEnd
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/statisticsfinland.json?apikey=' + this.apiKey, { start: start, end: end })
      } catch (e) {
        if (e.response && e.response.data && e.response.data.errorMessage) {
          this.showError(e.response.data.errorMessage)
          return
        }
      }
      if (response && response.data) {
        this.showNotification(this._('Data sent to Statistics Finland.'))
      } else {
        this.showError(this._('Error sending data to Statistics Finland.'))
      }
    },
    deleteReport () {
      if (!this.reportId) {
        return
      }
      if (this.deleteTimeout) {
        clearTimeout(this.deleteTimeout)
      }
      if (!this.deleteClicked) {
        this.deleteClicked = true
        this.deleteTimeout = setTimeout(() => {
          this.deleteClicked = false
        }, 3000)
        return
      }
      let obj = {
        id: this.reportId
      }
      axios.delete(this.baseDomain + this.shopId + '/scheduledreports/' + this.reportId + '.json?apikey=' + this.apiKey, obj)
      this.deleteClicked = false
      this.reset()
    },
    reset () {
      this.setParams({
        id: 0,
        format: 'xlsx',
        output: 'download'
      })
    },
    async setParams (params) {
      // Note to future optimisers: This is not the way. 
      // But we had to solve a race condition where the required filtered sources (all products etc) were not yet loaded. 
      // So, now there will be unnecessary loading but thats what it is...
      let extra = {}
      if (params.params) {
        try {
          extra = typeof params.params === 'string' ? JSON.parse(params.params) : params.params
        } catch (e) {
          extra = {}
        }
      }
      if (extra && extra.customers && !params.customers) {
        params.customers = Array.isArray(extra.customers) ? extra.customers.join(',') : extra.customers
      }
      if (extra && extra.emails && !params.emails) {
        params.emails = Array.isArray(extra.emails) ? extra.emails.join(',') : extra.emails
      }
      if (extra && extra.followup_products && !params.followup_products) {
        params.followup_products = Array.isArray(extra.followup_products) ? extra.followup_products.join(',') : extra.followup_products
      }
      this.reportType = this.reportTypes.find(type => type.id === params.type) || ''
      this.reportTitle = params.title || ''
      this.reportId = params.id
      if (parseInt(params.id)) {
        this.reportTime = 'scheduled'
        this.reportDaily = 'every'
        this.reportMonthly = 'every'
        this.reportWeekdays = []
        for (var i = 0; i < 7; i++) {
          if (parseInt(params.weekdays, 10) & Math.pow(2, i)) {
            this.reportWeekdays.push(i + 1)
          }
        }
        if (this.reportWeekdays.length) {
          this.reportDaily = 'selected-weekdays'
        }
        this.reportDays = []
        for (i = 0; i < 31; i++) {
          if (parseInt(params.days, 10) & Math.pow(2, i)) {
            this.reportDays.push(i + 1)
          }
        }
        if (this.reportDays.length) {
          this.reportDaily = 'selected-days'
        }
        this.reportMonths = []
        for (i = 0; i < 12; i++) {
          if (parseInt(params.months, 10) & Math.pow(2, i)) {
            this.reportMonths.push(i + 1)
          }
        }
        if (this.reportMonths.length) {
          this.reportMonthly = 'selected'
        }
        this.reportTimes = []
        if (params.times) {
          this.reportTimes = params.times.split(',')
        }
      } else {
        this.reportTime = 'now'
        this.reportWeekdays = []
        this.reportDays = []
        this.reportMonths = []
        this.reportTimes = []
        this.reportDaily = 'every'
        this.reportMonthly = 'every'
      }
      let start = this.reportStartRanges.find(range => range.id == params.start)
      if (start) {
        this.reportRangeStart = params.start
        this.exactStartDate = ''
      } else if (params.start) {
        this.reportRangeStart = 'exact'
        this.exactStartDate = DateTime.fromFormat(params.start, 'd.M.yyyy').toJSDate()
      } else {
        this.reportRangeStart = ''
        this.exactStartDate = ''
      }
      let end = this.reportEndRanges.find(range => range.id == params.end)
      if (end) {
        this.reportRangeEnd = params.end
        this.exactEndDate = ''
      } else if (params.end) {
        this.reportRangeEnd = 'exact'
        this.exactEndDate = DateTime.fromFormat(params.end, 'd.M.yyyy').toJSDate()
      } else {
        this.reportRangeEnd = ''
        this.exactEndDate = ''
      }
      this.reportFormat = params.format
      this.ensureSupportedFormat()
      this.reportOutput = params.output
      if (this.reportType.id === 'accommodationstatistics') {
        this.reportOutput = 'archive'
      }
      this.reportEmail = params.email
      let selected = null
      if (params.producttypes) {
        if(!(this.allReportProductTypes && this.allReportProductTypes.length)) {
          await this.loadProductTypes()
        }
        selected = params.producttypes.split(',')
        this.reportProductTypes = this.allReportProductTypes.filter(item => selected.includes(item.fulltype))
      } else {
        this.reportProductTypes = []
      }
      if (params.categories) {
        if(!(this.allReportCategories && this.allReportCategories.length)) {
          await this.loadCategories()
        }
        selected = params.categories.split(',')
        this.reportCategories = this.allReportCategories.filter(item => selected.includes(item.id))
      } else {
        this.reportCategories = []
      }
      if (params.products) {
        if(!(this.allReportProducts && this.allReportProducts.length)) {
          await this.loadProducts()
        }
        selected = params.products.split(',')
        this.reportProducts = this.allReportProducts.filter(item => selected.includes(item.id))
      } else {
        this.reportProducts = []
      }
      if (params.resources) {
        if(!(this.allReportResources && this.allReportResources.length)) {
          await this.loadResources()
        }
        selected = params.resources.split(',')
        this.reportResources = this.allReportResources.filter(item => selected.includes(item.id))
      } else {
        this.reportResources = []
      }
      if (params.saleschannels) {
        if(!(this.allReportChannels && this.allReportChannels.length)) {
          await this.loadChannels()
        }
        selected = params.saleschannels.split(',')
        this.reportChannels = this.allReportChannels.filter(item => selected.includes(item.origin))
      } else {
        this.reportChannels = []
      }
      if (params.poses) {
        if(!(this.allReportPoses && this.allReportPoses.length)) {
          await this.loadPoses()
        }
        selected = params.poses.split(',')
        this.reportPoses = this.allReportPoses.filter(item => selected.includes(String(item.id)))
      } else {
        this.reportPoses = []
      }
      if (params.deliverymethods) {
        if (!(this.allDeliveryMethods && this.allDeliveryMethods.length)) {
          await this.loadDeliveryMethods()
        }
        selected = params.deliverymethods.split(',')
        this.reportDeliveryMethods = this.allDeliveryMethods.filter(item => selected.includes(item.id))
      } else {
        this.reportDeliveryMethods = []
      }
      if (params.emails) {
        selected = String(params.emails).split(',').map(email => email.trim()).filter(Boolean)
        await this.loadCustomersByEmails(selected)
        this.reportCustomers = this.allReportCustomers
      } else if (params.customers) {
        selected = String(params.customers).split(',').filter(Boolean)
        await this.loadCustomersByIds(selected)
        this.reportCustomers = this.allReportCustomers.filter(item => selected.includes(String(item.id)))
      } else {
        this.reportCustomers = []
      }
      if (params.followup_products) {
        if (!(this.allReportProducts && this.allReportProducts.length)) {
          await this.loadProducts()
        }
        selected = String(params.followup_products).split(',')
        this.reportFollowupProducts = this.allReportProducts.filter(item => selected.includes(item.id))
      } else {
        this.reportFollowupProducts = []
      }
    },
    load () {
      this.loadCategories()
      this.loadProducts()
      this.loadProductTypes()
      this.loadResources()
      this.loadChannels()
      this.loadPoses()
      this.loadDeliveryMethods()
    },
    async loadCategories () {
      let response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/categories.json?version=' + this.locale + '&iSortCol_0=2&sSortDir_0=asc&iSortingCols=1')
      let ret = []
      if (response && response.data) {
        for (var i = 0; i < response.data.length; i++) {
          let d = response.data[i]
          ret.push({ id: d.id, name: d.name })
        }
      }
      this.allReportCategories = ret
    },
    async loadProducts () {
      let response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/products.json?version=' + this.locale + '&iSortCol_0=2&sSortDir_0=asc&iSortingCols=1&simple=true')
      let ret = []
      if (response && response.data) {
        for (var i = 0; i < response.data.length; i++) {
          let d = response.data[i]
          ret.push({ id: d.id, name: d.name })
        }
      }
      this.allReportProducts = ret
    },
    async loadProductTypes () {
      let response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/products.json?types=true&apikey=' + this.apiKey)
      let ret = []
      if (response && response.data) {
        for (var i = 0; i < response.data.length; i++) {
          let d = response.data[i]
          ret.push({ fulltype: d.type + '-' + d.subtype + '-' + d.displayedtype, title: d.title })
        }
      }
      this.allReportProductTypes = ret
    },
    async loadResources () {
      let response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/resources.json?version=' + this.locale + '&iSortCol_0=1&sSortDir_0=asc&iSortingCols=1&apikey=' + this.apiKey)
      let ret = []
      if (response && response.data) {
        for (var i = 0; i < response.data.length; i++) {
          let d = response.data[i]
          ret.push({ id: d.id, name: d.name })
        }
      }
      this.allReportResources = ret
    },
    async loadChannels () {
      let response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/orders.json?origins=true&apikey=' + this.apiKey)
      let ret = []
      if (response && response.data) {
        for (var i = 0; i < response.data.length; i++) {
          let d = response.data[i]
          ret.push({ origin: d.origin })
        }
      }
      this.allReportChannels = ret
    },
    async loadPoses () {
      let response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/pos.json?version=' + this.locale + '&iSortCol_0=1&sSortDir_0=asc&iSortingCols=1&apikey=' + this.apiKey)
      let ret = [
        { id: 0, name: this._('Non-POS sales') }
      ]
      if (response && response.data) {
        for (var i = 0; i < response.data.length; i++) {
          let d = response.data[i]
          ret.push({ id: d.id, name: d.name })
        }
      }
      this.allReportPoses = ret
    },
    searchCustomers: debounce(async function (query) {
      if (!query || String(query).length < 2) {
        return
      }
      this.customersLoading = true
      try {
        const response = await axios.get(this.baseDomain + this.shopId + '/customers.json?apikey=' + this.apiKey + '&sSearch=' + encodeURIComponent(query) + '&iDisplayStart=0&iDisplayLength=50&iSortingCols=1&iSortCol_0=1&sSortDir_0=asc')
        const rows = Array.isArray(response.data) ? response.data : []
        const selected = this.reportCustomers || []
        const byId = {}
        selected.forEach(item => { byId[item.id] = item })
        rows.forEach(d => {
          byId[d.id] = this.mapReportCustomer(d)
        })
        this.allReportCustomers = Object.values(byId)
      } catch (e) {
        this.allReportCustomers = this.reportCustomers || []
      }
      this.customersLoading = false
    }, 300),
    async loadCustomersByEmails (emails) {
      const loaded = []
      const seen = {}
      for (const email of emails) {
        if (!email) {
          continue
        }
        try {
          const response = await axios.get(this.baseDomain + this.shopId + '/customers.json?apikey=' + this.apiKey + '&sSearch=' + encodeURIComponent(email) + '&iDisplayStart=0&iDisplayLength=20&iSortingCols=1&iSortCol_0=1&sSortDir_0=asc')
          const rows = Array.isArray(response.data) ? response.data : []
          const match = rows.find(row => String(row.email || '').trim().toLowerCase() === email.toLowerCase()) || rows[0]
          if (match) {
            const mapped = this.mapReportCustomer(match)
            if (!mapped.email) {
              mapped.email = email
            }
            if (!seen[mapped.id]) {
              seen[mapped.id] = true
              loaded.push(mapped)
            }
          } else {
            loaded.push({ id: email, name: email, email })
          }
        } catch (e) {
          loaded.push({ id: email, name: email, email })
        }
      }
      this.allReportCustomers = loaded
    },
    async loadCustomersByIds (ids) {
      const loaded = []
      for (const id of ids) {
        if (!id) {
          continue
        }
        try {
          const response = await axios.get(this.baseDomain + this.shopId + '/customers/' + id + '.json?apikey=' + this.apiKey)
          if (response && response.data) {
            loaded.push(this.mapReportCustomer(response.data))
          }
        } catch (e) {}
      }
      this.allReportCustomers = loaded
    },
    async loadDeliveryMethods () {
      let response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/deliverymethods.json?apikey=' + this.apiKey)
      let ret = []
      if (response && response.data) {
        for (var i = 0; i < response.data.length; i++) {
          let d = response.data[i]
          ret.push({ id: d.id, name: d.name })
        }
      }
      this.allDeliveryMethods = ret
    },
    openRef (ref) {
      if (!ref || typeof ref !== 'string') {
        return
      }
      window.open(this.baseDomain + ref.substring(1) + '?apikey=' + this.apiKey)
    },
    addTime () {
      if (!this.newTime) {
        return
      }
      const n = DateTime.now().set({ hour: this.newTime.hours, minute: this.newTime.minutes })
      const t = n.toFormat(this.timeFormat)
      if (!this.reportTimes.includes(t)) {
        this.reportTimes.push(t)
      }
      this.newTime = ''
    },
    removeTime (time) {
      this.reportTimes = this.reportTimes.filter(t => t !== time)
    }
  },
  mounted () {
    this.load()
    if (this.component && this.component.initData && this.component.initData.setCreateReportParams) {
      this.setParams(this.component.initData.setCreateReportParams)
    }
    if(!this.events) {
      let events = {}
      events['setCreateReportParams'] = (message) => {
        this.setParams(message)
      }
      events['taskUpdate'] = (message) => {
        if (message && message.data && message.data.status === 'done') {
          if (message.data.requestid === this.requestId && message.data.ref) {
            if (this.selectedOutputs && this.selectedOutputs[message.data.requestid] && this.selectedOutputs[message.data.requestid] === 'download') {
              this.openRef(message.data.ref)
            }
            delete this.selectedOutputs[message.data.requestid]
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  },
  components: {
    DatetimePicker,
    Multiselect
  }
}

</script>

<style>
.itemselector-container {
  margin-left: 22px;
  margin-top: -5px;
}
.itemselector-container label.checkbox-inline {
  width: 55px;
}
.itemselector-container.seven-items label {
  float: left;
  width: 60px;
}
.itemselector-container.seven-items label:nth-child(7n+1) {
  clear: left;
  margin-left: 0px !important;
}
</style>